import { useEffect, useState } from 'react';
import { useAppStore } from '../stores/app-store';

/**
 * Hook to get the current resolved theme mode (light or dark)
 * Resolves 'system' preference to actual light/dark based on OS settings
 */
export function useThemeMode(): 'light' | 'dark' {
  const { mode } = useAppStore();
  const [resolvedMode, setResolvedMode] = useState<'light' | 'dark'>(() => {
    if (mode === 'system') {
      return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    }
    return mode;
  });

  useEffect(() => {
    if (mode !== 'system') {
      setResolvedMode(mode);
      return;
    }

    // For 'system' mode, watch for OS theme changes
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    
    const updateMode = () => {
      setResolvedMode(mediaQuery.matches ? 'dark' : 'light');
    };

    // Set initial value
    updateMode();

    // Watch for changes
    mediaQuery.addEventListener('change', updateMode);
    
    return () => mediaQuery.removeEventListener('change', updateMode);
  }, [mode]);

  return resolvedMode;
}
